import React, { useEffect, useState } from "react";
import SuperAdminAllResellerTable from "./SuperAdminAllResellerTable";
import { server_url } from "../../Config/API";

const SuperAdminAllRessellerTable = () => {
  const [reseller, setReseller] = useState([]);
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await fetch(
          `${server_url}/user/specific?fieldName=role&fieldValue=admin&page=1&limit=5`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem(
                "careSeeAccessToken"
              )}`,
            },
          }
        );
        const data = await response.json();
        setReseller(data?.data || []);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };

    fetchDoctors();
  }, [refetch]);

  const date = new Date();
  const day = date.getDate();
  const year = date.getFullYear();
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const monthName = months[date.getMonth()];
  const formattedDate = `${day} ${monthName} ${year}`;

  return (
    <div className="space-y-4 select-none">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <div>
          <p className="text-[11px] text-slate-400 font-bold uppercase tracking-wider">{formattedDate}</p>
        </div>
      </div>

      <div className="overflow-x-auto border border-slate-100 rounded-xl">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-50/75 border-b border-slate-100">
              <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Name</th>
              <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Email</th>
              <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Phone</th>
              <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Role</th>
              <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Status</th>
              <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider text-right">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {reseller.length > 0 ? (
              reseller.map((resellerData) => (
                <SuperAdminAllResellerTable
                  key={resellerData?._id}
                  refetch={() => setRefetch((p) => !p)}
                  setRefetch={() => setRefetch((p) => !p)}
                  resellerData={resellerData}
                />
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-6 text-xs text-slate-400">
                  No resellers found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SuperAdminAllRessellerTable;
